<div class="gallery-container">
  <div mat-dialog-title class="ds">
    <span>{{ appStrings.products_imageGallery }}</span>
    <button mat-icon-button class="close-dialog-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="ds gallery-content">
    <div class="image-viewer">
      @if (images.length > 1) {
        <button mat-icon-button class="nav-btn prev-btn" (click)="prev()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      }
      <div class="main-image-wrapper">
        <img [src]="images[currentIndex]" class="main-image" alt="" />
      </div>
      @if (images.length > 1) {
        <button mat-icon-button class="nav-btn next-btn" (click)="next()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>

    @if (images.length > 1) {
      <div class="thumbnails-strip">
        @for (img of images; track img; let i = $index) {
          <img
            [src]="img"
            [alt]="i"
            class="thumbnail"
            [class.active]="i === currentIndex"
            (click)="selectImage(i)"
          />
        }
      </div>
    }
  </div>

  <div mat-dialog-actions align="end" class="ds">
    <div class="dialog-btn-wrapper">
      <ds-button
        variant="label-only"
        size="medium"
        type="secondary"
        [label]="appStrings.button_close"
        (onClick)="close()">
      </ds-button>
    </div>
  </div>
</div>
